'use strict';

export default function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'column',
      height: 250,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '天候毎の平均消費電力',
      style: { fontSize: '14px' }
    },
    legend: {enabled: false},
    xAxis: {
      crosshair: true,
      labels: {
        useHTML: true,
        formatter: function () {
          if (typeof this.value !== 'string') { return; }
          return `<img class="statistics-weather-icon" src="vendor/weather-icons/${this.value}d.png"/>`;
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '平均消費電力 [kWh]',
        style: {'font-size': '13px'}
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      useHTML: true,
      formatter: function () {
        return `平均消費電力: ${this.y} kWh`;
      }
    },
    plotOptions: {
      column: {grouping: false}
    },
    series: [
      {
        name: '平均消費電力'
      }
    ]
  };
}



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/weather-stat-graph/weather-correlation-graph/weather-correlation-graph.config.js